import { render, staticRenderFns } from "./model-notation.vue?vue&type=template&id=53280613&scoped=true&"
import script from "./model-notation.vue?vue&type=script&lang=ts&"
export * from "./model-notation.vue?vue&type=script&lang=ts&"
import style0 from "./model-notation.vue?vue&type=style&index=0&id=53280613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53280613",
  null
  
)

export default component.exports